<template>
  <!--新建消息-->
  <div class="content AnewMessage">
    <div class="layui-fluid">
      <div class="layui-row">
        <div class="layui-col-md12">
          <div
            class="layui-row"
            style="margin-top: 20px;"
          >
            <div class="layui-col-md12">
              <form
                class="layui-form"
                action
                lay-filter="example"
              >
                <div class="layui-form-item">
                  <label class="layui-form-label">资讯标题：</label>
                  <div class="layui-input-block">
                    <input
                      type="text"
                      name="title"
                      lay-verify="title"
                      autocomplete="off"
                      placeholder="请输入标题"
                      class="layui-input"
                    />
                  </div>
                </div>
                <div class="layui-form-item date">
                  <label class="layui-form-label">发布时间：</label>
                  <div class="layui-input-block">
                    <el-date-picker v-model="release_time" type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">图片：</label>
                  <div class="layui-input-block">
                    <button
                      type="button"
                      class="layui-btn"
                      id="test1"
                    >上传图片</button>
                    <p
                      class="layui-elip"
                      style="color: red;font-size: 12px;margin-top: 10px;margin-bottom:0px;"
                       >支持上传png\jpg格式图片</p>
                    <p class="layui-elip"
                       style="color: red;font-size: 12px;">建议尺寸：宽750 ，高440</p>
                    <div class="layui-upload-list">
                      <img
                        class="layui-upload-img"
                        id="demo1"
                        style="width:100px"
                      />
                      <p id="demoText"></p>
                    </div>
                  </div>
                </div>
                <div class="layui-form-item">
                  <label
                    class="layui-form-label"
                    style="width: 110px;"
                  >所属会议：</label>
                  <div class="layui-input-block">
                    <el-select
                      v-model="cid"
                      placeholder="请选择会议"
                      style="width:100%"
                    >
                      <el-option
                        value
                        label="请选择会议"
                      ></el-option>
                      <el-option
                        v-for="items in huodong"
                        :key="items.id"
                        :value="items.id"
                        :label="items.name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">作者：</label>
                  <div class="layui-input-block">
                    <input
                      type="text"
                      name="author"
                      lay-verify="title"
                      autocomplete="off"
                      placeholder="请输入作者"
                      class="layui-input"
                    />
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">描述：</label>
                  <div class="layui-input-block">
                    <input
                           type="text"
                           name="summary"
                           lay-verify="title"
                           autocomplete="off"
                           placeholder="请输入描述"
                           class="layui-input"
                           />
  </div>
  </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">媒体：</label>
                  <div class="layui-input-block">
                    <input
                      type="text"
                      name="media"
                      lay-verify="title"
                      autocomplete="off"
                      placeholder="请输入媒体"
                      class="layui-input"
                    />
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">策划：</label>
                  <div class="layui-input-block">
                    <input type="text" name="plan" lay-verify="title" autocomplete="off" placeholder="请输入编辑" class="layui-input" />
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">编辑：</label>
                  <div class="layui-input-block">
                    <input type="text" name="edit" lay-verify="title" autocomplete="off" placeholder="请输入审校" class="layui-input" />
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">审校：</label>
                  <div class="layui-input-block">
                    <input type="text" name="proofread" lay-verify="title" autocomplete="off" placeholder="请输入策划" class="layui-input" />
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">是否是第三方资讯:</label>
                  <div class="layui-input-block">
                    <input
                      type="radio"
                      name="is_link"
                      value="0"
                      title="否"
                      lay-filter="is_link"
                      checked
                    />
                    <input
                      type="radio"
                      name="is_link"
                      value="1"
                      title="是"
                      lay-filter="is_link"
                    />
                  </div>
                </div>
                <div
                  class="layui-form-item layui-form-text"
                  id="zixun_content"
                >
                  <label class="layui-form-label">资讯内容：</label>
                  <div
                    class="layui-input-block"
                    id="con"
                    style="background:white"
                  >
                   <vue-ueditor-wrap v-model="msg" :config="myConfig"></vue-ueditor-wrap>
                  </div>
                </div>
                <div
                  class="layui-form-item"
                  id="zixun_link"
                  style="display:none"
                >
                  <label class="layui-form-label">资讯链接：</label>
                  <div class="layui-input-block">
                    <input
                      type="text"
                      name="link"
                      lay-verify="title"
                      autocomplete="off"
                      placeholder="请输入链接"
                      class="layui-input"
                    />
                  </div>
                </div>               
                <div class="layui-form-item">
                  <div class="layui-input-block">
                    <button
                      type="submit"
                      class="layui-btn"
                      lay-submit
                      lay-filter="demo1"
                    >保存</button>
                    <router-link
                      to="/Formation/Inforamtion"
                      style="margin-left:20px"
                    >
                      <button
                        type="reset"
                        class="layui-btn layui-btn-primary"
                      >取消</button>
                    </router-link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  name: "AnewMessage",
  data () {
    return {
      msg: '',
      cid: "",
      huodong: [],
      tid: "",
      img_logo: "",
      release_time:'',//发布时间
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: '100%',
        retainOnlyLabelPasted:false,
        toolbars: [[
          'source', '|', 'undo', 'redo',  '|',
          'bold', 'italic', 'underline', 'strikethrough', 'forecolor', 'backcolor', 'superscript', 'subscript',  'autotypeset', 'blockquote', 'pasteplain', '|','removeformat', 'formatmatch','cleardoc','|',
          'paragraph', 'fontfamily', 'fontsize', '|',
          'insertorderedlist', 'insertunorderedlist', 'rowspacingtop', 'rowspacingbottom', 'lineheight','indent', '|',
          'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
          'link', 'unlink', /*'anchor',*/ '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|', 'insertimage', 'emotion', /*'insertvideo', 'music', 'attachment',*//* 'map',*/ 'insertframe', 'background', '|',
          'horizontal',  'spechars', '|',
          'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', /*'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', */'|',
          /*'print',*/'selectall','135editor','searchreplace'
        ]],
        pasteplain:false,
        // 上传文件接口
        serverUrl: "/ac1/conference/uploadBase64",  
        UEDITOR_HOME_URL: './static/UEditor/'  
      }
    };
  },
  components: {
    VueUeditorWrap
  },
  created () {
    this.tid = this.$route.query.id;
  },
  methods: {
    /* 获取select值 */
    selsects () {
       var _this = this;
      /* 渲染会议select */
      let url =_this.APIurl.API.api.selectlist;
      this.$get(url).then((res) => {
        this.huodong = res.posts;
      });
    },
    /* 判断是否是通过编辑进入 */
    bianji () {
      var _this = this;
      layui.use(
        [
          "jquery",
          "element",
          "form",
          "laydate",
          "upload",
          "layedit",
          "layer",
          "table",
        ],
        function () {
          var layer = layui.layer;
          var $ = layui.jquery;
          var element = layui.element;
          var form = layui.form;
          var laydate = layui.laydate;
          var upload = layui.upload;
          var nowTime = new Date().valueOf();
          var table = layui.table;
          var layedit = layui.layedit;
          if (_this.tid != undefined)
          {
            let url = _this.APIurl.API.api.editall;
            var params = {
              id: _this.tid,
            };
            _this.$get(url, params).then((res) => {
              var lin = res.posts;
              _this.cid = lin.conference_id;
              if(lin.release_time !== 0){
                _this.release_time = new Date(lin.release_time*1000);
              }
              if (lin.jump_status == 1)
              {
                $("#zixun_content").hide();
                $("#zixun_link").show();
              } else if (lin.jump_status == 0)
              {
                $("#zixun_content").show();
                $("#zixun_link").hide();
              }
              var objs = {
                title: lin.name,
                author: lin.author,
                media: lin.source,
                summary: lin.summary,
                content: lin.text_content,
                link: lin.jump_link,
                is_link: lin.jump_status,
                proofread: lin.proofread,
                plan: lin.plan,
                edit: lin.edit,
              };
              var img = lin.uploadImgId_url;
              $("#demo1").attr("src", img);
              _this.img_logo = $("#demo1").attr("src");
              _this.msg=objs.content
              console.log(objs.content);
              form.val("example", objs);           
            });
          }
        }
      );
    },
    /* 提交表单 */
    submit () {
      /* 提交表格 */
      var _this = this;
      layui.use(
        [
          "jquery",
          "element",
          "form",
          "laydate",
          "upload",
          "layedit",
          "layer",
          "table",
        ],
        function () {
          var layer = layui.layer;
          var $ = layui.jquery;
          var element = layui.element;
          var form = layui.form;
          var laydate = layui.laydate;
          var upload = layui.upload;
          var nowTime = new Date().valueOf();
          var table = layui.table;
          var layedit = layui.layedit;      
          form.on("submit(demo1)", function (data) {
            let datas = data.field;
            let url = _this.APIurl.API.api.zixunsave;
            var params = {};
            if (_this.tid)
            {
              params = {
                id: _this.tid,
                title: datas.title,
                logo_url: _this.img_logo,
                conference_id: _this.cid,
                author: datas.author,
                summary:datas.summary,
                media: datas.media,
                is_link: datas.is_link,
                content: _this.msg,
                link: datas.link,
                proofread: datas.proofread,
                plan: datas.plan,
                edit: datas.edit,
                release_time:new Date(_this.release_time).getTime()/1000,
              };
            } else
            {
              params = {
                title: datas.title,
                logo_url: _this.img_logo,
                conference_id: _this.cid,
                author: datas.author,
                summary:datas.summary,
                media: datas.media,
                is_link: datas.is_link,
                content: _this.msg,
                link: datas.link,
                proofread: datas.proofread,
                plan: datas.plan,
                edit: datas.edit,
                release_time:new Date(_this.release_time).getTime()/1000,
              };
            }
            _this.$post(url, params).then((res) => {
              if (res.code == 1)
              {
                _this.$message({
                  message: "保存成功",
                  type: "success",
                  duration: 1000,
                });
                _this.$router.push({ path: "/Formation/Inforamtion" });
                _this.cid = "";
              } else
              {
                layer.msg("请填写完整信息");
              }
            });
            return false;
          });
        }
      );
    },
    /* 上传图片 */
    upload () {
      var _this = this;
      layui.use("upload", function () {
        var $ = layui.jquery,
          upload = layui.upload;
        //图片上传
        var uploadInst = upload.render({
          elem: "#test1",
          url: _this.APIurl.API.api.fujianupload, //改成您自己的上传接口
          before: function (obj) {
            //预读本地文件示例，不支持ie8
            obj.preview(function (index, file, result) {
              $("#demo1").attr("src", result); //图片链接（base64）
            });
          },
          done: function (res) {
            //如果上传失败
            if (res.code > 0)
            {
              return layer.msg("上传失败");
            }
            _this.upimg();
          },
          error: function () {
            //演示失败状态，并实现重传
            var demoText = $("#demoText");
            demoText.html(
              '<span style="color: #FF5722;">上传失败</span> <a class="layui-btn layui-btn-xs demo-reload">重试</a>'
            );
            demoText.find(".demo-reload").on("click", function () {
              uploadInst.upload();
            });
          },
        });
      });
    },
    /* 获取图片地址赋值参数 */
    upimg () {
      var _this = this;
      var lujing = $("#demo1").attr("src");
      let url = _this.APIurl.API.api.up_baimg;
      var params = {
        base64: lujing,
      };
      _this.$postform(url, params).then((res) => {
        _this.img_logo = res.posts[0].image;
      });
    },
  },
  mounted () {
    layui.use(["jquery", "element", "form"], function () {
      var $ = layui.jquery;
      var element = layui.element;
      var form = layui.form;
      element.render();
      form.render();
      /* 监听是否是第三方资讯 */
      form.on("radio(is_link)", function (data) {
        if (data.value == 1)
        {
          $("#zixun_content").hide();
          $("#zixun_link").show();
        } else if (data.value == 0)
        {
          $("#zixun_content").show();
          $("#zixun_link").hide();
        }
      });
    });
    this.upload();
    this.submit();
    this.bianji();
    this.selsects();
  },
  updated () { },
};
</script>

<style scoped>
.AnewMessage .layui-form-label {
  width: 100px;
}
.layui-input-block button {
  float: left;
  margin-right: 20px;
}
.layui-upload-list {
  margin-top: 50px;
  margin-bottom: 0px;
}
</style>
